export const initCountryAndLanguage = () => {
  if (!document.getElementById("footer")) {
    return;
  }

  const countryMenuItems: NodeListOf<HTMLLIElement> = document.querySelectorAll(
    "#footer .country .dropdown-menu li",
  );
  const languageMenuItems: NodeListOf<HTMLLIElement> = document.querySelectorAll(
    "#footer .language .dropdown-menu li",
  );

  countryMenuItems.forEach((countryMenuItem) => {
    countryMenuItem.addEventListener(
      "click",
      (event: MouseEvent) => {
        const target = event.target as HTMLLIElement;
        const countryIso = target.dataset.countryIso;

        if (countryIso) {
          window.location.href = `/country/${countryIso}/`;
        }
      },
      { passive: true },
    );
  });

  languageMenuItems.forEach((languageMenuItem) => {
    languageMenuItem.addEventListener(
      "click",
      (event) => {
        const target = event.target as HTMLLIElement;
        const language = target.dataset.language;

        if (language) {
          window.location.href = `/language/${language}/`;
        }
      },
      { passive: true },
    );
  });
};
